import { FC, memo, ReactNode, useCallback, useState } from 'react'
import IconArrowRight from 'remixicon/icons/Arrows/arrow-right-s-line.svg?react'

interface SpoilerProps {
  children?: ReactNode
  hideLabelName?: string
  showLabelName?: string
}

export const Collapse: FC<SpoilerProps> = (props) => {
  const { children, showLabelName = 'Развернуть', hideLabelName = 'Свернуть' } = props
  const [isShow, setIsShow] = useState(false)

  const handleToggle = useCallback(() => {
    setIsShow(!isShow)
  }, [isShow])

  return isShow ? (
    <>
      <div className="link flex cursor-pointer select-none gap-x-2" onClick={handleToggle}>
        <IconArrowRight className="-rotate-90" size="xs" />
        {hideLabelName}
      </div>
      {children}
    </>
  ) : (
    <div className="link flex cursor-pointer select-none gap-x-2" onClick={handleToggle}>
      <IconArrowRight size="xs" />
      {showLabelName}
    </div>
  )
}

export default memo(Collapse)
